'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { BackToSchool } from '@src/SectionRenderer/sections/backToSchool'

import { buildBackToSchoolConfig, widgetsToProductCards } from '../back-to-school-section-builders'

import type { FeaturedProductsShowcaseWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

const BackToSchoolWidgetComponent = (props: PLTypedWidgetProps<FeaturedProductsShowcaseWidgetData>) => {
  const data = props.data.featuredProductsShowcaseData
  // Products arrive as nested widgets (SINGLE_PRODUCT_CARD → productItem), like nested product widgets.
  const productCards = widgetsToProductCards(props.widgets)
  if (!data || !productCards.length) return null

  return <BackToSchool sectionConfig={buildBackToSchoolConfig(data, productCards)} />
}

export const BackToSchoolWidget: PLTypedWidgetInterface<
  FeaturedProductsShowcaseWidgetData,
  WidgetType.FEATURED_PRODUCTS_SHOWCASE
> = {
  id: WidgetType.FEATURED_PRODUCTS_SHOWCASE,
  errorBoundary: PLBaseErrorBoundary,
  render: BackToSchoolWidgetComponent,
}
